// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD4F0ioa47iwf058y7uN7Deer2QHgRBzdA",
    authDomain: "orderies-admin-dashboard.firebaseapp.com",
    databaseURL: "https://orderies-admin-dashboard.firebaseio.com",
    projectId: "orderies-admin-dashboard",
    storageBucket: "orderies-admin-dashboard.appspot.com",
    messagingSenderId: "581739270823",
    appId: "1:581739270823:web:57b08a47a45b7405dc8182"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
